<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:20px">
              <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Regions</v-btn>
              <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Cities</v-btn>
              <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Service Location</v-btn>
              <v-btn class="primary" v-on:click="sho4()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Third Party</v-btn>
              <v-btn class="primary" v-on:click="sho5()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Accounted Customers</v-btn>
              <v-btn v-on:click="sho6() && activate(1)" :class="{ active_el: active_el == 1 }" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px;color: #ffffff">Employees</v-btn>
              <v-btn class="primary" v-on:click="sho7()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">New Truck</v-btn>
              <v-btn class="primary" v-on:click="sho8()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Pickup</v-btn>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12>
          <v-flex xs3></v-flex>
          <v-flex xs6>
            <v-card style="margin-top:20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Employees</h3>
                <!--<v-btn flat class="primary" style="margin-left:350px;margin-bottom: 10px;margin-top:-10px" v-on:click="back()">Back</v-btn>-->
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <p style="text-align: left;margin-top:20px;margin-left:20px">Please register here to give access to this application</p>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:40px">
                      <label>Employee Name</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-flex d-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs5 style="">
                            <v-text-field
                              v-model="firstname"
                              label="First Name"
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 style="margin-left:20px">
                            <v-text-field
                              v-model="lastname"
                              label="Last Name"
                              outline
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Email</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-text-field
                        v-model="email"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Work service Location / Hub</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-overflow-btn
                        :items="dropdown_list"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      firstname: '',
      lastname: '',
      email: '',
      dropdown_list: ['Mumbai', 'Kolkata', 'Pune', 'Nagpur']
    }
  },
  methods: {
    submit () {
      this.$router.push('/Truckingemployeesreport')
    },
    sho1 () {
      this.$router.push('/Truckingaddregions')
    },
    sho2 () {
      this.$router.push('/Truckingaddcities')
    },
    sho3 () {
      this.$router.push('/Truckingservicelocation')
    },
    sho4 () {
      this.$router.push('/Truckingthirdpartytransporters')
    },
    sho5 () {
      this.$router.push('/Truckingaccountedcustomers')
    },
    sho6 () {
      this.$router.push('/Truckingemployees')
    },
    sho7 () {
      this.$router.push('/Truckingaddnewtruck')
    },
    sho8 () {
      this.$router.push('/Truckingpickuprequest')
    },
    activate: function (el) {
      this.active_el = el
    }
  }
}
</script>
<style>
 .active_el{
    background-color: #00C853
  }
</style>



// WEBPACK FOOTER //
// src/components/Truckingemployees.vue